module.exports = __webpack_public_path__ + "img/K_Porjai.d5fccc46.jpg";